<p>cps-pid-search works!</p>
